import { Component, OnInit, Input } from '@angular/core';
import { MemberBenefits } from '../../models/route-signposts-model';

@Component({
    selector: 'aa-route-member-benefit',
    templateUrl: './route-member-benefit.component.html',
    styleUrls: ['./route-member-benefit.component.scss'],
    standalone: false
})
export class RouteMemberBenefitComponent implements OnInit {

  @Input() data: MemberBenefits;
  public memberBenefitLogo: any;

  constructor() { }

  ngOnInit() {
    // console.log('MB', this.data);
    this.memberBenefitLogo = {'background-image': 'url(' + this.data.brandLogo + ')'};
  }

  private benefitOffer(defaltIndex: number = 0) {
    return this.data.benefitOffers[defaltIndex];
  }

  get memberBenefitTxt() {
    const benefit = this.benefitOffer();
    const percent = benefit.offerPercent || '';
    return `AA Member Benefit <b>(${percent})</b>`;
  }

  get address() {
    const address = this.data.address;
    const addArray: Array<any> = [];

    if (address) {
      (address.lineOne) ? addArray.push(address.lineOne) : '';
      (address.lineTwo) ? addArray.push(address.lineTwo) : '';
      (address.lineThree) ? addArray.push(address.lineThree) : '';
    }

    return addArray.join(', ');
  }

  openMemberBenefit() {
    const win = window.open('https://www.theaa.com/member-benefits/all', 'MemberBenefit');
    win.focus();
  }

}
